import { ORG_TYPES } from './orgTypes';

export const ORG_TYPES_ALLOW_TO_POST_VOLOPS: ReadonlyArray<
  Readonly<{
    id: string;
    name: string;
  }>
> = ORG_TYPES.filter((type) => ['NONPROFIT', 'GOVERNMENT'].includes(type.id));
